export enum CloudProvider {
  AZURE = 'Azure',
  AWS = "AWS"
}
